export class Testimonials {

    /**
     * Constructor Testimonials
     * @param duration
     */
    constructor(duration = 5000) {
        this.duration = duration;
        this.index = 0;
        this.$slider = $('.c-testimonials');
        this.$items = this.$slider.find('.c-testimonials__item');
        this.$left = this.$slider.find('.js-prev-testimonial');
        this.$next = this.$slider.find('.js-next-testimonial');

        this.next();

        // bind events
        this.$left.on('click',() => this.prev());
        this.$next.on('click', () => this.next());
    }

    /**
     * Updates the current slide index
     */
    next(){
        this.index = ( this.index <  this.$items.length - 1 )? this.index + 1 : 0;
        this.move();
    }

    /**
     * Updates the current slide index
     */
    prev(){
        this.index = (this.index > 0)? this.index - 1 : this.$items.length - 1;
        this.move();
    }

    /**
     * Updates the current slide index
     */
    move(){
        // stop the current timeout
        clearInterval(this.timeout);
        // fadeout existing items
        this.$items.fadeOut();
        // fade next item in after the other item has fadeoud
        setTimeout(()=> {
            this.$items.eq(this.index).fadeIn();
        }, 200);
        // start new iteration
        this.startNextIteration();
    }

    startNextIteration(){
        this.timeout = setTimeout(() => this.next(), this.duration);
    }
}